module.exports = __webpack_public_path__ + "static/img/STEVE_SMITH.32d585b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/STEVE_SMITH.jpg
// module id = BG8x
// module chunks = 0